<template>
  <v-autocomplete
    v-model="contextModel"
    :items="currency"
    :error-messages="validationMessage"
    item-text="symbol"
    item-value="symbol"
    :label="contextLabel"
    :rules="rules"
    :menu-props="{ 'min-width': '90px' }"
    :readonly="readonly"
  />
</template>

<script>
import Currency from "src/staticData/CurrencyTypes";

export default {
  name: "CurrencySelect",
  props: {
    readonly: {
      required: false,
      default: false
    },
    model: {
      required: true
    },
    validationMessage: {
      type: Array,
      default: function() {
        return [];
      }
    },
    label: {
      default: false
    },
    rules: {
      required: false,
      default: function() {
        return [];
      }
    }
  },
  data: () => ({
    currency: Currency
  }),
  created() {
    if (this.model == null) {
      this.contextModel = "PLN";
    }
  },
  computed: {
    contextLabel() {
      if (this.label === false) {
        return this.$t("global.currency");
      }
      return this.label;
    },
    contextModel: {
      set: function(value) {
        this.$emit("update:model", value);
      },
      get: function() {
        return this.model;
      }
    }
  }
};
</script>

<style scoped></style>
